module.exports = __webpack_public_path__ + "static/media/dna-based.111bc5a4.jpg";